module.exports = __webpack_public_path__ + "img/load.83770001.gif";